import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from 'vuex-persistedstate'
import {
  logIn,
  decodeToken,
  fetchSession,
  fetchUser,
  fetchUserPermissions,
  fetchUserRoles,
  fetchCurrentPageId,
  fetchUserNavigation,
  fetchUserPhotoThumbnail
} from '@/api'
import modules from '@/store/modules'

Vue.use(Vuex)

const state = {
  user: {},
  userPermissions: [],
  userNavigation: {},
  userPhotoThumbnail: null,
  currentPageId: null,

  Sidebar_drawer: null,
  Customizer_drawer: false,
  SidebarColor: 'white',
  SidebarBg: '',
}

const actions = {
  doLogIn (context, email, password) {
    return logIn(email, password).then((response) => {
      return response.data
    })
  },
  decodeToken (context, token) {
    return decodeToken(token).then(response => {
      return response.data
    })
  },
  fetchSession () {
    return fetchSession().then((payload) => {
      return payload.data
    })
  },
  fetchUser (context, loginId) {
    return fetchUser(loginId).then(payload => {
      context.commit('setUser', payload.data)
    })
  },
  fetchUserPermissions (context, loginId) {
    return fetchUserPermissions(loginId).then(payload => {
      context.commit('setUserPermissions', payload.data)
    })
  },
  fetchUserRoles (context, loginId) {
    return fetchUserRoles(loginId).then(payload => {
      return payload.data
    })
  },
  fetchCurrentPageId (context, path) {
    return fetchCurrentPageId(path).then(payload => {
      context.commit('setCurrentPageId', payload.data)
    })
  },
  fetchUserNavigation (context, loginId) {
    return fetchUserNavigation(loginId).then(response => {
      context.commit('setUserNavigation', response.data)
    })
  },
  fetchUserPhotoThumbnail (context, loginId) {
    return fetchUserPhotoThumbnail(loginId).then(response => {
      context.commit('setUserPhotoThumbnail', response.data)
    })
  }
}

const mutations = {
  setUser (state, payload) {
    state.user = payload
  },
  setUserPermissions (state, payload) {
    state.userPermissions = payload
  },
  setCurrentPageId (state, payload) {
    for (let page of payload) {
      state.currentPageId = page.pageId
    }
  },
  setUserNavigation (state, payload) {
    const navigation = []
    for (let header in payload) {
      // Restructure items.
      const items = []
      for (let item of payload[header]) {
        items.push({
          title: item.name,
          href: '#',
          to: item.path
        })
      }
      navigation.push({
        title: header,
        group: header,
        children: items
      })
    }
    state.userNavigation = navigation
  },
  setUserPhotoThumbnail (state, payload) {
    state.userPhotoThumbnail = payload.thumbnail
  },

  SET_SIDEBAR_DRAWER(state, payload) {
    state.Sidebar_drawer = payload
  },
  SET_CUSTOMIZER_DRAWER(state, payload) {
    state.Customizer_drawer = payload
  },
  SET_SIDEBAR_COLOR(state, payload) {
    state.SidebarColor = payload
  },

}

const getters = {
  getUser (state) {
    return state.user
  },
  getCurrentPageId (state) {
    return state.currentPageId
  },
  getUserNavigation (state) {
    return state.userNavigation
  },
  getUserPhotoThumbnail (state) {
    return state.userPhotoThumbnail
  }
}

const store = new Vuex.Store({
  modules,
  state,
  actions,
  mutations,
  getters,
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ]
})

export default store
